module.exports = __webpack_public_path__ + "static/media/icon_pharmacy_technology.e98fc78c.png";